/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UndoIcon from '@mui/icons-material/Undo';
import Snackbar from '@mui/material/Snackbar';
import TablePagination from '@mui/material/TablePagination';
import {

    Box,
    Card,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Modal,
    Typography,
    Button,
    Alert
} from '@material-ui/core';
import Grid from '@mui/material/Grid';
import Loader from 'react-loader-spinner';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    root: {
        backgroundColor: '#000',
        color: '#fff',
        padding: '10px',
        border: 'none',
        borderRadius: '5px',
        textTransform: 'uppercase',
        fontWeight: 'bold'
    }
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
};

const styletable = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1350,
    bgcolor: 'white',
    border: '2px solid #fff',
    boxShadow: 24,
    p: 4
};

const istyle = {
    color: 'red'
};

const AddNewExtraChargesResult = ({
    customers,
    flagstatus,
    fromdate,
    todate,
    datesearch,
    loaderflag,
    exportlist,
    handleExportGrid,
    exportflag,
    handleExportGridTwo,
    exportlisttwo,
    exportflagver,
    exportflagverCSV,
    handelCsvButon,
    invoicelistexportcsv,
    handleViewInvoice,
    handleDeleteSettlement,
    erorMessage,
    visible,
    handleCloseMessage,
    ...rest
}) => {
    const [invoicelist, setInvoicelList] = useState([]);

    const [loaderstate, setLoaderstate] = useState(false);

    const [openunchecked, setOpenUnchecked] = useState(false);

    const [rowsPerPage, setRowsPerPage] = useState(20);

    const [page, setPage] = useState(0);

    const [settlemtSno, setSettlemtSno] = useState('');

    const [settlementId, setSettlementId] = useState('');

    const handleClose = () => {
        setOpenUnchecked(false);
    };

    useEffect(async () => {
        if (customers.length > 0) {
            setInvoicelList(customers);
            setRowsPerPage(20);
            setPage(0);
        } else {
            setInvoicelList([]);
        }
    }, [customers, loaderflag]);

    useEffect(() => {
        setLoaderstate(loaderflag);
    }, [loaderflag]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleConfirmDeleteSettlement = (item) => {
        setOpenUnchecked(true);
        setSettlemtSno(item.sno);
        setSettlementId(item.settleid);

    };

    const handleDeleteSettlements = () => {
        handleDeleteSettlement(settlemtSno, settlementId);
        setOpenUnchecked(false);
    }

    return (
        <Card {...rest}>
            <PerfectScrollbar>
                <Box sx={{ flexGrow: 1 }} style={{ display: 'block' }}>
                    <Grid
                        container
                        spacing={2}
                        style={{ marginTop: '10px', paddingLeft: '10px' }}
                    >
                        <Grid item xs={2}>
                            <h2>New Extra Charges </h2>
                        </Grid>

                        <Loader
                            visible={loaderstate}
                            type="Puff"
                            color="#00BFFF"
                            height={45}
                            width={45}
                            timeout={300000}
                        />

                        <Box
                            sx={{ flexGrow: 1 }}
                            style={{
                                marginTop: '24px',
                                fontWeight: 'bolder',
                                color: 'red'
                            }}
                        >
                            {loaderstate === false && invoicelist && invoicelist.length === 0
                                ? 'Sorry there is no records'
                                : ''}
                        </Box>

                    </Grid>
                </Box>
                <Box sx={{ minWidth: 1350 }}>

                    <Table id="emp">
                        <TableHead>
                            <TableRow>

                                <TableCell>Settlement No</TableCell>
                                <TableCell>Extra Charges</TableCell>
                                <TableCell>Extra Amount</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>CreatedBy</TableCell>
                                <TableCell>Comment</TableCell>
                                <TableCell> Action </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {invoicelist && invoicelist.length > 0 && invoicelist
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((customer, index) => (
                                    <TableRow hover key={index[0]}>

                                        <TableCell> {customer.settleid} </TableCell>
                                        <TableCell> {customer.Extra_charges} </TableCell>
                                        <TableCell> {`$ ${customer.Set_Extra_Amount}`} </TableCell>
                                        <TableCell> {customer.Set_Status} </TableCell>
                                        <TableCell> {customer.Createdby} </TableCell>
                                        <TableCell> {customer.Comment} </TableCell>

                                        <TableCell>
                                            {customer.Set_Status == 'Un-Approved' && customer.Createdby !== 'ERP' ?
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="medium"
                                                    onClick={() => handleConfirmDeleteSettlement(customer)}
                                                >
                                                    Delete
                                                </Button>
                                                :
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    disabled
                                                    size="medium"
                                                >
                                                    Delete
                                                </Button>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>

                        <TableRow>
                            <TableCell colSpan={10}>
                                <TablePagination
                                    rowsPerPageOptions={[20, 50, 100, 200]}
                                    component="div"
                                    count={invoicelist.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableCell>
                        </TableRow>
                    </Table>
                </Box>
            </PerfectScrollbar>

            {/* delete settlemnt popup model */}
            <Modal
                open={openunchecked}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>

                    <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                        <h3 style={{ color: '#BC0707' }}> Do you want to delete {settlementId} settlement ? </h3>
                    </Typography>
                    <Typography id="modal-modal-footer" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                        <Button variant="contained"
                            onClick={handleDeleteSettlements}
                        >
                            Okay
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            variant="outlined"
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                    </Typography>
                </Box>
            </Modal>

            <Snackbar
                open={visible}
                autoHideDuration={3000}
                onClose={handleCloseMessage}
            >
                <Alert
                    onClose={handleCloseMessage}
                    severity={erorMessage == "Settlement has been successfully added" ? "success" : "error"}
                    sx={{ width: '100%' }}
                >
                    {erorMessage && erorMessage}

                </Alert>
            </Snackbar>
        </Card>
    );
};

AddNewExtraChargesResult.propTypes = {
    customers: PropTypes.array.isRequired
};

export default AddNewExtraChargesResult;
